document.addEventListener("DOMContentLoaded", () => {
  const slideshow = document.querySelector(".custom-hm-slideshow");
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll(".custom-hm-slide");
  const navType = slideshow.dataset.nav;
  const navContainer = document.querySelector(".custom-hm-slideshow-nav");

  let index = 0;
  const speed = parseInt(slideshow.dataset.speed) || 3000;
  const autoRotate = slideshow.dataset.auto === "true";
  let interval;

  // --- Build Navigation ---
  if (navType !== "none") {
    slides.forEach((_, i) => {
      const btn = document.createElement("button");
      if (navType === "numbers") {
        btn.textContent = i + 1;
        btn.classList.add("number");
      }
      btn.addEventListener("click", () => {
        index = i;
        showSlide(index);
        resetAuto();
      });
      navContainer.appendChild(btn);
    });
  }

  const navButtons = navContainer.querySelectorAll("button");

  function showSlide(i) {
    slideshow.style.transform = `translateX(-${i * 100}%)`;
    navButtons.forEach((btn, idx) => {
      btn.classList.toggle("active", idx === i);
    });
  }

  function nextSlide() {
    index = (index + 1) % slides.length;
    showSlide(index);
  }

  function resetAuto() {
    if (autoRotate) {
      clearInterval(interval);
      interval = setInterval(nextSlide, speed);
    }
  }

  // Init
  showSlide(index);
  resetAuto();
});
